import { render, staticRenderFns } from "./AtomDescriptionNoHtml.vue?vue&type=template&id=43a546cc&scoped=true"
import script from "./AtomDescriptionNoHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomDescriptionNoHtml.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a546cc",
  null
  
)

export default component.exports